module.exports = __webpack_public_path__ + "static/media/logo.b2ff7d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 322
// module chunks = 0